import React from "react";
import hassanImg from "./hassan.jpg";
import Footer from "./Footer";

function Team() {
  return (
    <div>
      <div className="responsive-container-block container" style={{padding: "80px 0"}} id="team">
        <p className="text-blk team-head-text" style={{ color: "#37517e" }}>
          Our Team
        </p>
        <p style={{ color: "gray", textAlign: "center" , margin:"-20px 0 60px 0"}}>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quo, nihil
          dolorum molestiae perspiciatis minus consequatur incidunt asperiores
          totam sit aliquam, qui repellat rerum culpa voluptatem. Laudantium
          dolorem fuga in quaerat?
        </p>
        <div className="responsive-container-block">
          <div className="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
            <div className="team__card">
              <div className="team-image-wrapper">
                <img
                  className="team-member-image"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/ET7.15.png"
                />
              </div>
              <p className="text-blk name">Davis Isabelle</p>
              <p className="text-blk position">CEO</p>
              <p className="text-blk feature-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
              <div className="social-icons">
                <a href="https://www.twitter.com" target="_blank">
                  <img
                    className="twitter-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg"
                  />
                </a>
                <a href="https://www.facebook.com" target="_blank">
                  <img
                    className="facebook-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
            <div className="team__card">
              <div className="team-image-wrapper">
                <img className="team-member-image" src={hassanImg} />
              </div>
              <p className="text-blk name">Hassan ElAmri</p>
              <p className="text-blk position">Their Husband</p>
              <p className="text-blk feature-text">
                i've the power of 6 horses 🔥🔥🔥
              </p>
              <div className="social-icons">
                <a href="https://www.twitter.com" target="_blank">
                  <img
                    className="twitter-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg"
                  />
                </a>
                <a href="https://www.facebook.com" target="_blank">
                  <img
                    className="facebook-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="responsive-cell-block wk-desk-3 wk-ipadp-3 wk-tab-6 wk-mobile-12 card-container">
            <div className="team__card">
              <div className="team-image-wrapper">
                <img
                  className="team-member-image"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/expert1.png"
                />
              </div>
              <p className="text-blk name">Ellie May</p>
              <p className="text-blk position">CEO</p>
              <p className="text-blk feature-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
              <div className="social-icons">
                <a href="https://www.twitter.com" target="_blank">
                  <img
                    className="twitter-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon.svg"
                  />
                </a>
                <a href="https://www.facebook.com" target="_blank">
                  <img
                    className="facebook-icon"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/Icon-1.svg"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default Team;
